
		import Async from 'preact-cli/async-component';

		function load(cb) {
			require.ensure([], function (require) {
				cb( require("!!../../../../../.local/lib/node_modules/preact-cli/node_modules/babel-loader/lib/index.js??ref--0!./index.js") );
			}, "route-home");
		}

		export default Async(load);
	


//////////////////
// WEBPACK FOOTER
// ./routes/home/index.js
// module id = E1C8
// module chunks = 17